import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import getAPIbaseURL from "../../utils/helpers";
import i18n from "../../i18n";
const API_URL = `${getAPIbaseURL()}/delegations`;

// Fetch all delegations
export const fetchDelegations = createAsyncThunk(
  "delegations/fetchDelegations",
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.fetchDelegations"));
    }
  }
);
export const fetchOfficialDelegationHolidays = createAsyncThunk(
  "delegations/fetchOfficialDelegationHolidays",
  async ({ delegationId, year, languageIsoCode }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${getAPIbaseURL()}/delegations/${delegationId}/holidays/import`,
        {},
        {
          params: { year, languageIsoCode: languageIsoCode || "EN" },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.fetchOfficialHolidays"));
    }
  }
);
export const importDelegationHolidays = createAsyncThunk(
  "delegations/importDelegationHolidays",
  async ({ delegationId, year, subdivisionCode }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");

      const params = new URLSearchParams({
        year,
        languageIsoCode: "PT",
      });

      if (subdivisionCode) {
        params.append("subdivisionCode", subdivisionCode);
      }

      const response = await axios.post(
        `${getAPIbaseURL()}/delegations/${delegationId}/holidays/import?${params.toString()}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data || i18n.t("slices.delegationsSlice.error.importHolidays")
      );
    }
  }
);
// Fetch delegation by id
export const fetchDelegationById = createAsyncThunk(
  "delegations/fetchDelegationById",
  async (delegationId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/${delegationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.fetchDelegation"));
    }
  }
);
export const fetchDelegationHolidays = createAsyncThunk(
  "delegations/fetchDelegationHolidays",
  async (delegationId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${getAPIbaseURL()}/delegations/${delegationId}/holidays`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.generic"));
    }
  }
);
// Create delegation
export const createDelegation = createAsyncThunk(
  "delegations/createDelegation",
  async (delegationData, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${API_URL}/`, delegationData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(i18n.t("slices.delegationsSlice.success.created"));
      return response.data;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.createDelegation"));
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.createDelegation"));
    }
  }
);

// Update delegation
export const updateDelegation = createAsyncThunk(
  "delegations/updateDelegation",
  async ({ delegationId, updates }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(`${API_URL}/${delegationId}`, updates, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(i18n.t("slices.delegationsSlice.success.updated"));
      return response.data;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.updateDelegation"));
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.updateDelegation"));
    }
  }
);

// Delete delegation
export const deleteDelegation = createAsyncThunk(
  "delegations/deleteDelegation",
  async (delegationId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/${delegationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(i18n.t("slices.delegationsSlice.success.deleted"));
      return delegationId;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.deleteDelegation"));
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.deleteDelegation"));
    }
  }
);

export const excludeOfficialHoliday = createAsyncThunk(
  "delegations/excludeOfficialHoliday",
  async ({ delegationId, name, date }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${getAPIbaseURL()}/delegations/${delegationId}/holidays/exclude`,
        { name, date, user_id: null, excluded: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(i18n.t("slices.delegationsSlice.success.holidayExcluded"));
      return res.data;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.excludeHoliday"));
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.generic"));
    }
  }
);

// filter delegations
export const filterDelegations = createAsyncThunk(
  "delegations/filterDelegations",
  async (params, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const queryParams = new URLSearchParams(params).toString();
      const response = await axios.get(`${API_URL}/filter?${queryParams}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.filterDelegations"));
    }
  }
);
// fetch subdivisions
export const fetchSubdivisions = createAsyncThunk(
  "delegations/fetchSubdivisions",
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${getAPIbaseURL()}/delegations/subdivisions/PT?languageIsoCode=PT`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("API subdivisions:", res.data);

      return res.data;
    } catch (error) {
      console.error(error.response);
      return thunkAPI.rejectWithValue(
        error.response?.data || i18n.t("slices.delegationsSlice.error.fetchSubdivisions")
      );
    }
  }
);

// fetch delegation members
export const fetchDelegationMembers = createAsyncThunk(
  "delegations/fetchDelegationMembers",
  async (delegationId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_URL}/${delegationId}/members`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.fetchMembers"));
    }
  }
);

// add member to delegation
export const addDelegationMember = createAsyncThunk(
  "delegations/addDelegationMember",
  async ({ delegationId, userId }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${API_URL}/${delegationId}/members`,
        { user_id: userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(i18n.t("slices.delegationsSlice.success.memberAdded"));
      return res.data;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.addMember"));

      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.addMember"));
    }
  }
);

// remove member from delegation
export const removeDelegationMember = createAsyncThunk(
  "delegations/removeDelegationMember",
  async ({ delegationId, userId }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/${delegationId}/members/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(i18n.t("slices.delegationsSlice.success.memberRemoved"));
      return userId;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.removeMember"));
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.removeMember"));
    }
  }
);


// 1. Create delegation holiday
export const createDelegationHoliday = createAsyncThunk(
  "delegations/createDelegationHoliday",
  async ({ delegationId, holidayData }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(`${getAPIbaseURL()}/delegations/${delegationId}/holidays`, holidayData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(i18n.t("slices.delegationsSlice.success.holidayAdded"));
      return res.data;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.createHoliday"));
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.generic"));
    }
  }
);

// delete delegation holiday
export const deleteDelegationHoliday = createAsyncThunk(
  "delegations/deleteDelegationHoliday",
  async (holidayId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${getAPIbaseURL()}/delegations/holidays/${holidayId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(i18n.t("slices.delegationsSlice.success.holidayRemoved"));
      return holidayId;
    } catch (error) {
      toast.error(i18n.t("slices.delegationsSlice.error.removeHoliday"));
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.delegationsSlice.error.generic"));
    }
  }
);

const delegationSlice = createSlice({
  name: "delegations",
  initialState: {
    items: [],
    current: null,
    filtered: [],
    members: [],
    subdivisions: {},
    officialHolidays: [],
    isLoading: false,
    error: null,
    message: null,
  },
  reducers: {
    clearDelegationState: (state) => {
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDelegations.fulfilled, (state, action) => {
        state.items = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchDelegationById.fulfilled, (state, action) => {
        const existingHolidays = state.current ? state.current.holidays : [];

        state.current = {
          ...action.payload,
          holidays: existingHolidays
        };
        state.isLoading = false;
      })
      .addCase(fetchSubdivisions.fulfilled, (state, action) => {
        state.subdivisions = action.payload;
        state.isLoading = false;
      })
      .addCase(createDelegation.fulfilled, (state, action) => {
        state.items.push(action.payload);
        state.message = i18n.t("slices.delegationsSlice.success.created");
        state.isLoading = false;
      })
      .addCase(updateDelegation.fulfilled, (state, action) => {
        const index = state.items.findIndex((d) => d.id === action.payload.id);
        if (index !== -1) state.items[index] = action.payload;
        state.message = i18n.t("slices.delegationsSlice.success.updated");
        state.isLoading = false;
      })
      .addCase(deleteDelegation.fulfilled, (state, action) => {
        state.items = state.items.filter((d) => d.id !== action.payload);
        state.message = i18n.t("slices.delegationsSlice.success.deleted");
        state.isLoading = false;
      })
      .addCase(filterDelegations.fulfilled, (state, action) => {
        state.filtered = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchDelegationHolidays.fulfilled, (state, action) => {
        if (state.current) {
          state.current.holidays = action.payload;
        }
        state.isLoading = false;
      })
      .addCase(fetchOfficialDelegationHolidays.fulfilled, (state, action) => {
        state.officialHolidays = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchDelegationMembers.fulfilled, (state, action) => {
        state.members = action.payload;
        state.isLoading = false;
      })
      .addCase(addDelegationMember.fulfilled, (state, action) => {
        state.members.push(action.payload);
        state.isLoading = false;
      })
      .addCase(removeDelegationMember.fulfilled, (state, action) => {
        state.members = state.members.filter((m) => m.id !== action.payload);
        state.isLoading = false;
      })
      .addCase(excludeOfficialHoliday.fulfilled, (state, action) => {
        if (state.current) {
          if (!state.current.holidays) state.current.holidays = [];
          state.current.holidays.push(action.payload);
        }
        state.isLoading = false;
      })
      .addCase(createDelegationHoliday.fulfilled, (state, action) => {
        if (state.current && state.current.id === action.payload.delegation_id) {
          if (!state.current.holidays) state.current.holidays = [];
          state.current.holidays.push(action.payload);
        }
        state.isLoading = false;
      })
      .addCase(deleteDelegationHoliday.fulfilled, (state, action) => {
        if (state.current && state.current.holidays) {
          state.current.holidays = state.current.holidays.filter(
            (h) => h.id !== action.payload
          );
        }
        state.isLoading = false;
      })
      .addMatcher(
        (action) => action.type.startsWith("delegations/") && action.type.endsWith("/pending"),
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("delegations/") && action.type.endsWith("/rejected"),
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      );
  },
});

export const { clearDelegationState } = delegationSlice.actions;
export default delegationSlice.reducer;